module.exports = __webpack_public_path__ + "img/Med03.04-1-20060212-002_tag.2f858960.jpg";